import type { SkuDto } from '@pl/domain';

const wordsOf = (text: string) => text.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);

/**
 * True when every word of `query` is one of the SKU's words, from its code, name, colour or
 * attribute values, in any order. Words match whole, so "cat6 blue" is CAT6 CMR 1000ft Blue and
 * not the CAT6A blue. The exception is the last word, while it is still being typed: that one
 * matches as a prefix, so "cat6 bl" already finds it. A trailing space ends that word too.
 * Codes split into words the same way, so "C6-CMR-B" finds C6-CMR-BLU.
 */
export function skuMatches(sku: Pick<SkuDto, 'code' | 'name' | 'colourName' | 'attributes'>, query: string): boolean {
  const asked = wordsOf(query);
  if (asked.length === 0) return false;
  const typing = !/[\s]$/.test(query);
  const own = new Set(wordsOf([sku.code, sku.name, sku.colourName ?? '', ...Object.values(sku.attributes ?? {}).map(String)].join(' ')));
  return asked.every((w, i) => (typing && i === asked.length - 1 ? [...own].some((o) => o.startsWith(w)) : own.has(w)));
}
